module.exports = __webpack_public_path__ + "modules/platform/img/file_type_mp3_icon.png";